// import { UserInfo } from 'interfaces/types'

import { State } from './types'

export const initialState: State = {
  isLoggedIn: false,
  authorizing: true,
  isMobileSsr: true,
  userInfo: undefined,
  openLogoutPopup: false,
  newBookmark: [],
  isOpenDueDatePopup: false,
  dueDateRedirectLink: '',
  dueDate: '',
  currentDomain: '',
  articlePlayingId: -1,
  showConfirmLeavePagePopup: null,
  chatwootWebsiteToken: '',
  zaloConfig: null,
  showFooter: false,
  collectingAction: [],
  cartNumber: 0,
  communityJoined: [],
}
